'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoommateIcon = function (_React$Component) {
    _inherits(RoommateIcon, _React$Component);

    function RoommateIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RoommateIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoommateIcon.__proto__ || Object.getPrototypeOf(RoommateIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'roommate-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_538', transform: 'translate(-48.456 -3687.5)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Bold_538' },
                        _react2.default.createElement('path', { fill: color, id: 'Shape_2593', d: 'M61.92,3700.96a.341.341,0,0,0,.132.24.313.313,0,0,0,.266.04,5.7,5.7,0,0,1,2.214-.15.474.474,0,0,0,.392-.13l2.5-2.36a.481.481,0,0,0,.052-.64,5.781,5.781,0,0,0-4.607-2.28,5.684,5.684,0,0,0-2.366.51.481.481,0,0,0-.175.74A7.133,7.133,0,0,1,61.92,3700.96Z' }),
                        _react2.default.createElement('path', { fill: color, id: 'Oval_522', d: 'M62.412,3694.72a3.36,3.36,0,1,0-3.372-3.36A3.363,3.363,0,0,0,62.412,3694.72Z' }),
                        _react2.default.createElement('path', { fill: color, id: 'Shape_2594', d: 'M60.384,3701.33a.369.369,0,0,0,.1-.27,5.784,5.784,0,0,0-11.52-.26.58.58,0,0,0,.145.45.586.586,0,0,0,.431.19H60.118A.375.375,0,0,0,60.384,3701.33Z' }),
                        _react2.default.createElement('path', { fill: color, id: 'Oval_523', d: 'M54.252,3694.72a3.36,3.36,0,1,0-3.372-3.36A3.363,3.363,0,0,0,54.252,3694.72Z' }),
                        _react2.default.createElement('path', { fill: color, id: 'Shape_2595', d: 'M69.62,3698.69h1.9a.477.477,0,0,1,.48.48v1.89a.5.5,0,0,1-.141.35l-3.9,3.89a.239.239,0,0,0-.061.24,4.278,4.278,0,1,1-2.859-2.87.248.248,0,0,0,.234-.05l4.021-3.8A.453.453,0,0,1,69.62,3698.69Zm-6.855,9.11a1.668,1.668,0,1,0,0-2.36A1.668,1.668,0,0,0,62.765,3707.8Z', fillRule: 'evenodd' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RoommateIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return RoommateIcon;
}(_react2.default.Component);

exports.default = RoommateIcon;